import React from 'react';

/**
 * `ButtonBack` is a thin styled wrapper around the shared `Button` component.
 *
 * It uses the "outlined" button styling plus the `cms-btn-back` CMS hook class,
 * and forwards all behaviour (disabled/waiting/click handling) to `Button`.
 */

import Button from './Button';

type ButtonBackProps = {
  name: string;
  text: string;
  disabled?: boolean;
  onClick: (callback?: () => void) => void;
  waitText?: string;
  waitValue?: boolean;
  waitOnClick?: boolean;
  additionalClassNames?: string;
};

export const ButtonBack = ({
  name,
  text,
  disabled,
  onClick,
  waitText,
  waitValue,
  waitOnClick,
  additionalClassNames
}: ButtonBackProps): JSX.Element => {
  let classes = 'button button-outlined-basic';

  if (additionalClassNames) {
    classes += ` ${additionalClassNames}`;
  }

  classes += ' cms-btn-back';

  return (
    <Button
      name={name}
      text={text}
      disabled={disabled}
      className={classes}
      onClick={onClick}
      waitValue={waitValue}
      waitText={waitText}
      waitOnClick={waitOnClick}
    />
  );
};
